import { CustomAddress } from '../../interfaces/address.interface';
import { IPhonebookContact } from '../phonebook/phonebook.interface';
import { BaseModel } from '../_base/model.class';
import { Subscription } from './company.interface';

export interface SubUser {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  notes?: string;
  createdBy: string;
  createdAt: Date;
}

export interface SubProperty {
  propertyId: string;
  name: string;
  notes?: string;
  createdBy: string;
  createdAt: Date;
}

export class Company extends BaseModel {
  constructor(
    private _id?: string,
    private code?: string,
    private types?: string[],
    private name?: string,
    private vatNumber?: string,
    private taxCode?: string,
    private email?: string,
    private pec?: string,
    private sdiCode?: string,
    private legalAddress?: CustomAddress,
    private operativeAddress?: CustomAddress,
    private phone?: string,
    private fax?: string,
    private webSiteUrl?: string,
    private legalName?: string,
    private legalLastName?: string,
    private legalResidentialAddress?: CustomAddress,
    private legalTaxCode?: string,
    private legalEmail?: string,
    private subUsers?: [SubUser],
    private subProperties?: [SubProperty],
    private subscription?: Subscription,
    private phonebook?: IPhonebookContact[],
    private documents?: string,
    private createdBy?: string,
    private createdAt?: Date,
    private updatedBy?: string,
    private updatedAt?: Date,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'types',
      'name',
      'email',
      'legalAddress',
      'createdBy',
      'createdAt',
    ]);
  }
}
